<template>
	<div class="loading-dash">
		<div class="smpte-bars">
			<div class="stripe med-gray"></div>
			<div class="stripe lt-gray"></div>
			<div class="stripe med-yellow"></div>
			<div class="stripe med-cyan"></div>
			<div class="stripe green"></div>
			<div class="stripe magenta"></div>
			<div class="stripe med-red"></div>
			<div class="stripe med-blue"></div>
			<div class="stripe med-gray"></div>
			<div class="pill lt-cyan"></div>
			<div class="pill dk-purple"></div>
			<div class="pill lt-gray"></div>
			<div class="pill lt-blue"></div>
			<div class="pill lt-yellow"></div>
			<div class="pill lt-purple"></div>
			<div class="pill gradient"></div>
			<div class="pill lt-red"></div>
			<div class="square dk-gray"></div>
			<div class="square black"></div>
			<div class="square white"></div>
			<div class="square black"></div>
			<div class="square black1"></div>
			<div class="square black2"></div>
			<div class="square black3"></div>
			<div class="square black4"></div>
			<div class="square dk-gray"></div>
		</div>
		<div class="overlay">
			<div class="block">
				<div class="image">
					<img src="images/logo-emblem.svg">
				</div>
				<div class="textblock">
					<div class="dashportal">
						<strong>Dash</strong>Portal
					</div>
					<div class="version">
						{{ version }}
					</div>
				</div>
			</div>
			<div v-if="registrationCode" class="regcode">
				<p>To register this client, please visit the admin panel and enter the following code:</p>
				<p class="code">{{ registrationCode }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Loading',
		props: ['registrationCode'],
		data() {
			return {
				version: "Version 1.5"
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	.loading-dash {
		position: relative;
		width: 100%;
		height: 100%;

		.overlay {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			z-index: 100;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;

			.block {
				background-color: #000;
				width: 75%;
				height: 30%;
				margin-top: 8%;
				display: flex;
			}

			.image {
				padding: 2em;
				height: 100%;
				flex: 0 0 25%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.textblock {
				padding: 2em;
				flex: 0 0 70%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				color: #fff;
			}

			.dashportal {
				font-family: @font-raleway;
				font-size: 9em;
				line-height: 1em;
				text-align: center;
				width: 100%;
			}

			.version {
				font-family: @font-pixel;
				font-size: 3em;
				line-height: 1em;
				text-align: center;
				width: 100%;
			}

			.regcode {
				background-color: #000;
				width: 75%;
				margin-top: 2%;
				color: #fff;
				font-size: 2.2em;
				padding: 1em;
				text-align: center;
				text-transform: uppercase;
				font-family: @font-raleway;

				p {
					margin: 0;

					&.code {
						font-family: @font-pixel;
						margin: 1em 0 0;
						font-size: 3em;
						line-height: 1em;
					}
				}
			}
		}
	}

	.smpte-bars {
		display: flex;
		flex-wrap: wrap;
		height: 100%;

		.stripe {
			width: 10%;
			height: 58%;

			&.med-gray {
				width: 15%;
			}
		}

		.pill {
			width: 10%;
			height: 10%;

			&.lt-cyan,
			&.lt-blue,
			&.lt-yellow,
			&.lt-red {
				width: 15%;
			}

			&.lt-gray,
			&.gradient {
				width: 60%;
			}
		}

		.square {
			height: 22%;

			&.dk-gray {
				width: 15%;
			}

			&.black {
				width: 15%;
			}

			&.white {
				width: 20%;
			}

			&.black1 {
				width: 3%;
			}

			&.black2 {
				width: 4%;
			}

			&.black3 {
				width: 3%;
			}

			&.black4 {
				width: 10%;
			}
		}

		.med-gray {
			background-color: #666;
		}

		.lt-gray {
			background-color: #bfbfbf;
		}

		.med-yellow {
			background-color: #bfc100;
		}

		.med-cyan {
			background-color: #00bfc0;
		}

		.green {
			background-color: #00c100;
		}

		.magenta {
			background-color: #c100c1;
		}

		.med-red {
			background-color: #c10000;
		}

		.med-blue {
			background-color: #0000c2;
		}

		.lt-cyan {
			background-color: #0ff;
		}

		.lt-yellow {
			background-color: #ff0;
		}

		.dk-purple {
			background-color: #00204d;
		}

		.lt-purple {
			background-color: #32006c;
		}

		.lt-blue {
			background-color: #00f;
		}

		.lt-red {
			background-color: #f00;
		}

		.dk-gray {
			background-color: #262626;
		}

		.black {
			background-color: #000;
		}

		.white {
			background-color: #fff;
		}

		.black1 {
			background-color: #050505;
		}

		.black2 {
			background-color: #000;
		}

		.black3 {
			background-color: #0a0a0a;
		}

		.black4 {
			background-color: #000;
		}

		.gradient {
			background-image: linear-gradient(to right, #000 0%,#fff 100%);
		}
	}
</style>


// WEBPACK FOOTER //
// loading-dash.vue?50ca6cca